import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { Polygon } from "react-leaflet";

import "leaflet/dist/leaflet.css";
import "leaflet.awesome-markers/dist/leaflet.awesome-markers.css";
import "leaflet.awesome-markers/dist/leaflet.awesome-markers";

// import { helper } from "../../../../utils/helpers/helper";
import { mapActions, drawingActions } from "../../../../store/actions";
import { EditablePopup } from "../index";
import { helper } from "../../../../utils/helpers/helper";

import "./style.css";
let color;
var oldPolygons = [];
let currentPolygon;
let newPolygon;
// let layerId;
function PolygonComponent(props) {
  let {
    polyData,
    refreshPolyData,
    deletePolygon,
    deletePolygonIndex,
    leafletLayer,
  } = props;
  const [polygonDataSet, setPolygonDataSet] = useState(polyData);
  let polygonRef = useRef({});
  polygonRef = {};

  useEffect(() => {
    // if (refreshPolyData === true) {
    setPolygonDataSet(polyData);
    // }
    if (deletePolygon === true) {
      leafletLayer.map((obj) => {
        if (obj.id === deletePolygonIndex) {
          let element = obj.layer;
          element.remove();
        }
        return null;
      });
      //FIND INDEX NO.
      if (polygonRef && !helper.isEmpty(polygonRef[deletePolygonIndex])) {
        let selectedPolyIndex = deletePolygonIndex;
        let selectedPoly = polygonRef[selectedPolyIndex];
        let element = selectedPoly.leafletElement;
        element.remove();
      }
    }
  }, [
    refreshPolyData,
    leafletLayer,
    polyData,
    deletePolygon,
    deletePolygonIndex,
  ]);

  const removeCustomZone = (index) => {
    props.deletePolygonAction(index);
  };

  const openEditScreen = (poly) => {
    if (
      poly.editPolygonIndex !== null &&
      props.updatePolygonIndex !== null &&
      props.updatePolygonIndex === poly.id &&
      props.editPolygonIndex === poly.id
    ) {
      props.editPolygonAction();
    } else {
      props.setPreference(poly);
    }
  };

  return polygonDataSet.map((poly, index) => {
    color = helper.get_polygon_color(poly?.created_by?.user_type);
    newPolygon = (
      <Polygon
        key={`poly-${index}`}
        color={color}
        positions={poly.points}
        ref={(input) => {
          polygonRef[poly?.id] = input;
        }}
      >
        <EditablePopup
          open
          editable
          removable
          sourceKey={poly?.id}
          sourceId={index}
          removalCallback={() => {
            removeCustomZone(poly?.id);
          }}
          openEditScreen={() => {
            openEditScreen(poly);
          }}
        >
          <>
            <p>
              Geofence:{" "}
              <span>
                {helper.capitalizeFirstLetter(poly?.support_data?.title)}
              </span>
            </p>
            <p>
              Alerts:{" "}
              <span>
                {helper.capitalizeFirstLetter(poly?.support_data?.alert)}
              </span>
            </p>
            <p>
              Status:{" "}
              <span>
                {helper.capitalizeFirstLetter(poly?.support_data?.status)}
              </span>
            </p>
            {helper.get_user_role() === "admin" && (
              <p>
                Created by: <span>{poly?.created_by?.email}</span>
              </p>
            )}
          </>
        </EditablePopup>
      </Polygon>
    );
    currentPolygon = { index: poly?.id, element: newPolygon };
    oldPolygons.push(currentPolygon);
    return newPolygon;
  });
}

function mapStateToProps(state) {
  const {
    polyData,
    editPolygon,
    editPolygonIndex,
    updatePolygonIndex,
    refreshPolyData,
    deletePolygon,
    deletePolygonIndex,
    leafletLayer,
  } = state.drawing;
  return {
    polyData,
    editPolygon,
    updatePolygonIndex,
    editPolygonIndex,
    refreshPolyData,
    deletePolygon,
    deletePolygonIndex,
    leafletLayer,
  };
}
const mapDispatchToProps = {
  setZoomLevel: mapActions.setZoomLevel,
  setPreference: drawingActions.setPreference,
  editPolygonAction: drawingActions.editPolygon,
  deletePolygonAction: drawingActions.deletePolygon,
};

export default connect(mapStateToProps, mapDispatchToProps)(PolygonComponent);
